import { __makeTemplateObject } from "tslib";
import { css, radius } from '../../../foundation';
import { RcPaper } from '../../Paper';
import { drawerRadius, RcDrawerClasses } from '../utils';
export var DrawerStyle = function (props) {
    var radiusProp = props.radius, inlinePaper = props.inlinePaper, _a = props.anchor, anchor = _a === void 0 ? 'left' : _a;
    var currRadiusValue = (function () {
        if (!radiusProp)
            return null;
        var radiusValue = radius(radiusProp)(props);
        if (radiusValue === '0px' || radiusValue === 0)
            return null;
        return drawerRadius[anchor]
            .map(function (x) { return (x === 1 ? radiusValue : 0); })
            .join(' ');
    })();
    return css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    .", " {\n      border-radius: ", ";\n\n      ", "\n    }\n  "], ["\n    .", " {\n      border-radius: ", ";\n\n      ",
        "\n    }\n  "])), RcDrawerClasses.paper, currRadiusValue, inlinePaper && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        background: transparent;\n        box-shadow: none;\n        align-items: center;\n        justify-content: center;\n        overflow: unset;\n\n        ", " {\n          border-radius: ", ";\n        }\n      "], ["\n        background: transparent;\n        box-shadow: none;\n        align-items: center;\n        justify-content: center;\n        overflow: unset;\n\n        ", " {\n          border-radius: ", ";\n        }\n      "])), RcPaper, currRadiusValue));
};
var templateObject_1, templateObject_2;
